import { render, staticRenderFns } from "./recente.vue?vue&type=template&id=0e157865&scoped=true"
import script from "./recente.vue?vue&type=script&lang=js"
export * from "./recente.vue?vue&type=script&lang=js"
import style0 from "./recente.vue?vue&type=style&index=0&id=0e157865&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e157865",
  null
  
)

export default component.exports